export default function containsHtml(str) {
  return Array.from(
    new DOMParser().parseFromString(str, "text/html").body.childNodes
  ).some(({ nodeType }) => nodeType == 1);
}
